import { render } from "./UserAccountLockManager.vue?vue&type=template&id=3ab36990&scoped=true"
import script from "./UserAccountLockManager.vue?vue&type=script&lang=js"
export * from "./UserAccountLockManager.vue?vue&type=script&lang=js"

import "./UserAccountLockManager.vue?vue&type=style&index=0&id=3ab36990&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab36990"]])

export default __exports__